// version.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, firstValueFrom, map, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionService {

    private bc = new BroadcastChannel('app-version');

    private _clientVersion: string;
    public get clientVersion() {
        return this._clientVersion;
    }

    constructor(
        private http: HttpClient
    ) {
        this.init();
        this.bc.onmessage = () => location.reload();
    }

    private init() {
        return this.http
            .get<{ version: string }>('/assets/version.json')
            .pipe(
                tap(v => this._clientVersion = v?.version ?? null),
                catchError(() => {
                    this._clientVersion = null;
                    return of(null)
                })
            )
            .subscribe();
    }

    public hasUpdates() {
        return this.http
            .get<{ version: string }>(`/assets/version.json?ts=${Date.now()}`)
            .pipe(
                map(v => this.clientVersion !== v.version),
                catchError(() => of(false))
            );

    }

    public reload() {
        location.reload();
    }

    public reloadAll() {
        this.reload();
        this.bc.postMessage('reload');
    }
}
